// @flow
import * as React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { isMultiplasMedidasSelecionadas } from "../../util";

import { modosExibicao } from "./modosExibicao/ModoExibicao";
import SelecaoCheckboxBase from "../comum/SelecaoCheckboxBase";
import { useI18n } from "@quantum/i18n";

import {
  GRUPAMENTO_MEDIDAS_PERSONALIZADAS,
  type ModoApp,
  MODO_APP_SERIES,
  MODO_APP_NORMAL,
  GRUPAMENTO_MEDIDAS_SERIES,
  GRUPAMENTO_MEDIDAS_QUANTITATIVAS,
  GRUPAMENTO_MEDIDAS_EMPRESAS,
  MODO_APP_EXCEL,
  GRUPAMENTO_MEDIDAS_QUALITATIVAS,
} from "../../model";
import {
  type ActionCreator,
  getIndiceMedidaEditada,
  getMedidaSelecionada,
  selecionarExibirConfiguracoesAvancadas,
  getTipoCalculoSelecionado,
} from "../../state";

import { SelecaoEscalaMoeda, SelecaoCasasDecimais } from "./configuracoes";

import {
  FORMATACAO_MOEDA_MILHARES,
  ID_ESCALA_MOEDA_UNIDADES,
  ID_ESCALA_MOEDA_MILHARES,
  MODO_EXIBICAO_MEDIDA_QUALITATIVA,
  MODOS_EXIBICAO_SERIES_COM_FLAG_ULTIMA_NEGOCIACAO,
  MODOS_EXIBICAO_CASAS_DECIMAIS_ESPECIFICAS_MODO_SERIES,
} from "../../model/constantes";

import ModalErroAdicionarMedida from "./modal-erro-adicionar-medida";

import { ProvedorDoContextoEdicaoMedidas } from "./Contexto";

import "./area-edicao-medidas.css";
import { connectMedidas } from "./utils";
import AreaAdicionarMedidas from "./AreaAdicionarMedidas";

import {
  isMedidaOuSecundariasComEscalaMoeda,
  isMedidaOuSecundariasComCasasDecimais,
} from "../../model";
import CheckboxUltimaNegociacaoMes from "./configuracoes/periodos/CheckboxUltimaNegociacaoMes/CheckboxUltimaNegociacaoMes";

const MODOS_EXIBICAO_COM_CONFIGURACOES_DE_PERIODO_SOMENTE = [
  "ACOES_PONTUAL_DIARIO",
  "PONTUAL_CARTEIRA",
  "PONTUAL_DIARIO",
  "PONTUAL_DIARIO_SEM_PERIODICIDADE",
  "PONTUAL_MENSAL",
  "SERIES_COM_FONTE",
  "PERIODO_DIARIO_SEM_PERIODICIDADE",
];

type Props = {
  exibirEdicao: boolean,
  grupamentoMedidaSelecionado: string,
  modoExibicaoSelecionado: ?any,
  semSelecaoDePeriodo?: ?boolean,
  semSelecaoDePeriodiciade?: ?boolean,
  semSelecaoDeAjusteDias?: ?boolean,
  modoApp: ModoApp,
  exibirConfiguracoesAvancadas: Boolean,
  selecionarExibirConfiguracoesAvancadas: ActionCreator,
};

function AreaEdicaoMedidas({
  grupamentoMedidaSelecionado,
  exibirEdicao,
  modoExibicaoSelecionado,
  semSelecaoDePeriodo = false,
  semSelecaoDePeriodiciade = false,
  semSelecaoDeAjusteDias = false,
  modoApp,
  exibirConfiguracoesAvancadas,
  selecionarExibirConfiguracoesAvancadas,
}: Props) {
  const { translate } = useI18n();
  const indiceMedidaEditada = useSelector(getIndiceMedidaEditada);
  const medidaSelecionada = useSelector(getMedidaSelecionada);
  const tipoCalculoSelecionado = useSelector(getTipoCalculoSelecionado);

  if (!modoExibicaoSelecionado) return null;

  if (!exibirEdicao) return null;

  if (
    (modoApp === MODO_APP_NORMAL &&
      modoExibicaoSelecionado === MODO_EXIBICAO_MEDIDA_QUALITATIVA) ||
    (modoApp !== MODO_APP_SERIES &&
      isMultiplasMedidasSelecionadas(medidaSelecionada) &&
      modoExibicaoSelecionado !== MODO_EXIBICAO_MEDIDA_QUALITATIVA)
  ) {
    return <AreaAdicionarMedidas />;
  }

  const grupamentosComPersonalizacaoSemAvancadas =
    grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_SERIES ||
    grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_QUANTITATIVAS ||
    grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS;

  const exibicaoPeriodoSemCasaDecimalEscalaMoeda =
    MODOS_EXIBICAO_COM_CONFIGURACOES_DE_PERIODO_SOMENTE.includes(
      modoExibicaoSelecionado
    ) &&
    !isMedidaOuSecundariasComCasasDecimais(medidaSelecionada) &&
    !isMedidaOuSecundariasComEscalaMoeda(
      medidaSelecionada,
      tipoCalculoSelecionado
    );

  return (
    <>
      {modoApp === MODO_APP_SERIES &&
        grupamentosComPersonalizacaoSemAvancadas &&
        !MODOS_EXIBICAO_COM_CONFIGURACOES_DE_PERIODO_SOMENTE.includes(
          modoExibicaoSelecionado
        ) && (
          <div
            className={
              "AreaEdicaoMedidas__check-configuracoes-avancadas--escondido"
            }
          >
            <SelecaoCheckboxBase
              itens={[
                {
                  id: 0,
                  traducao: translate(
                    "configuracaoRelatorio.configuracoesAvancadas"
                  ),
                },
              ]}
              itensSelecionados={exibirConfiguracoesAvancadas ? [0] : []}
              onChange={() =>
                selecionarExibirConfiguracoesAvancadas(
                  !exibirConfiguracoesAvancadas
                )
              }
              campoId="id"
              campoDescricao="traducao"
            />
          </div>
        )}

      {(modoApp === MODO_APP_SERIES &&
        ((grupamentosComPersonalizacaoSemAvancadas &&
          !exibirConfiguracoesAvancadas) ||
          exibicaoPeriodoSemCasaDecimalEscalaMoeda)) ||
      (modoApp === MODO_APP_EXCEL &&
        grupamentoMedidaSelecionado ===
          GRUPAMENTO_MEDIDAS_QUALITATIVAS) ? null : (
        <div
          key={indiceMedidaEditada}
          className={classNames("AreaEdicaoMedidas", {
            "AreaEdicaoMedidas--personalizada":
              grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_PERSONALIZADAS,
          })}
          style={{ display: exibirEdicao ? "block" : "none" }}
          title={
            process.env.NODE_ENV === "development"
              ? "Modo exibição: " +
                modoExibicaoSelecionado +
                "\nFormatação: " +
                (medidaSelecionada != null ? medidaSelecionada.formatacao : "")
              : null
          }
        >
          <ModalErroAdicionarMedida />
          <div className="AreaEdicaoMedidas__propriedades">
            <ProvedorDoContextoEdicaoMedidas
              exibirSelecaoPeriodo={!semSelecaoDePeriodo}
              exibirSelecaoPeriodicidade={!semSelecaoDePeriodiciade}
              exibirSelecaoAjusteDias={!semSelecaoDeAjusteDias}
            >
              {modosExibicao[modoExibicaoSelecionado].componente}
              <div className="AreaEdicaoMedidas__configuracoes-formatacao">
                {medidaSelecionada &&
                  isMedidaOuSecundariasComEscalaMoeda(
                    medidaSelecionada,
                    tipoCalculoSelecionado
                  ) &&
                  grupamentoMedidaSelecionado !==
                    GRUPAMENTO_MEDIDAS_PERSONALIZADAS &&
                  modoApp === MODO_APP_SERIES && (
                    <SelecaoEscalaMoeda
                      valorPadrao={
                        medidaSelecionada.formatacao ===
                        FORMATACAO_MOEDA_MILHARES
                          ? ID_ESCALA_MOEDA_MILHARES
                          : ID_ESCALA_MOEDA_UNIDADES
                      }
                      nomeMedida={
                        !isMultiplasMedidasSelecionadas(medidaSelecionada)
                          ? medidaSelecionada.nome
                          : ""
                      }
                    />
                  )}
                {grupamentoMedidaSelecionado !==
                  GRUPAMENTO_MEDIDAS_PERSONALIZADAS &&
                  modoApp === MODO_APP_SERIES && (
                    <div className="ConfiguracaoMedida">
                      <div className="ConfiguracaoMedida__box">
                        <SelecaoCasasDecimais
                          className="ConfiguracaoMedida__fixed"
                          id="casasDecimais"
                          nomeMedida={
                            !isMultiplasMedidasSelecionadas(medidaSelecionada)
                              ? medidaSelecionada.nome
                              : ""
                          }
                          casasDecimaisDefault={
                            MODOS_EXIBICAO_CASAS_DECIMAIS_ESPECIFICAS_MODO_SERIES[
                              modoExibicaoSelecionado
                            ]
                          }
                        />
                      </div>
                      {MODOS_EXIBICAO_SERIES_COM_FLAG_ULTIMA_NEGOCIACAO.includes(
                        medidaSelecionada.modoExibicaoModoSeries
                      ) && <CheckboxUltimaNegociacaoMes />}
                    </div>
                  )}
              </div>
            </ProvedorDoContextoEdicaoMedidas>
          </div>
          {modoApp === MODO_APP_NORMAL && <AreaAdicionarMedidas />}
        </div>
      )}
    </>
  );
}

export default connectMedidas({
  selecionarExibirConfiguracoesAvancadas,
})(AreaEdicaoMedidas);
